import { Icon } from "@/components/BaseComponents/Icon";

export const MobileFilterSelectIcon = (props) => (
	<Icon viewBox={undefined} {...props}>
		<line x1="0" y1="0" x2="5" y2="5" strokeWidth="2px" stroke="currentColor" />
		<line
			x1="5"
			y1="5"
			x2="10"
			y2="0"
			strokeWidth="2px"
			stroke="currentColor"
		/>
	</Icon>
);
